import React, { Component } from 'react';
import { Slider as SliderMui } from '@mui/material';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import $ from 'jquery';
import { getTranslatedKey } from '../Utils/TranslateUtils';

export class Slider extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  PrettoSlider = styled(SliderMui)({
    color: '#fff',
    margin: 0,
    padding: 0,
    height: 6,
    '& .MuiSlider-track': {
      border: 'none'
    },
    '& .MuiSlider-thumb': {
      height: 17,
      width: 17,
      backgroundColor: '#febf00',
      border: '1px solid #febf00',
      '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
        boxShadow: 'inherit'
      },
      '&:before': {
        display: 'none'
      }
    }
  });

  render() {
    return (
      <>
        <Box
          sx={{
            width: window.innerWidth < 1024 ? (window.innerWidth < 768 ? (window.innerWidth < 464 ? '90%' : '90%') : '90%') : '320px',
            lineHeight: window.innerWidth < 464 ? '10px' : window.innerWidth < 1024 ? '30px' : '20px'
          }}>
          <this.PrettoSlider
            valueLabelDisplay="auto"
            aria_label={getTranslatedKey('aria_sliderMap')}
            getAriaLabel={() => getTranslatedKey('aria_laberThumb') + '"' + this.props.name + '"'}
            title="Slider"
            value={typeof this.props.transparenciaFons !== 'undefined' ? Math.round(this.props.transparenciaFons * 100) : 100}
            onChange={(e, val) => this.props.onChangeTransparenciaMapa(this.props.fonsActiu, val)}
            disabled={!this.props.enabled}
          />
        </Box>
      </>
    );
  }
}
